import axios from 'axios';

const BASE_URL = (process.env.REACT_APP_API_BASE_URL || '/springboot6hv37').replace(/\/$/, '')

export const api = axios.create({
    baseURL: BASE_URL,
});

// 请求拦截器
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('Token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const API = {
    getCarousel: () => `${BASE_URL}/config/list`,
    getProjects: (params) => `${BASE_URL}/jianshenxiangmu/list?${new URLSearchParams(params)}`,
    uploadFile: () => `${BASE_URL}/file/upload`,
    saveProject: () => `${BASE_URL}/jianshenxiangmu/add`,
};

export const apiCall = (url, method = 'GET', data = null) => {
    return axios({
        url,
        method,
        data,
        headers: {
            Authorization: `Bearer ${localStorage.getItem('Token')}`,
        },
    });
};

export default API;
